// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import arrowUpIcon from "@/assets/icons/arrow-up.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type ArrowUpIconProps = Omit<IconProps, "name">;

export function ArrowUpIcon(props: ArrowUpIconProps): React.ReactNode {
  return <Icon name={arrowUpIcon} {...props} />;
}
